<template>
  <div class="sc-form-table aj-form-table" ref="scFormTable" :style="{ 'height': _height }" v-loading="loading">
    <el-table :data="data" ref="table" border stripe :show-summary="showSummary" :summary-method="getSummaries"
      :height="height == 'auto' ? null : '100%'">
      <el-table-column type="index" :width="myTitle ? myTitleWidth : '50'" fixed="left" align="center">
        <template #header>
          <el-button v-if="!hideAdd" type="primary" icon="el-icon-plus" size="small" circle @click="rowAdd"></el-button>
        </template>
        <template #default="scope">
          <div
            :class="['sc-form-table-handle', { 'sc-form-table-handle-delete': !hideDelete && disableDeleteCondition(scope.row) }]">
            <span>{{ myTitle ? covertTitle(scope.row.title, scope.$index) : (scope.$index + 1) }}</span>
            <el-button v-if="!hideDelete && disableDeleteCondition(scope.row)" type="danger" icon="el-icon-delete"
              size="small" plain circle @click="rowDel(scope.row, scope.$index)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="50" v-if="dragSort">
        <template #default>
          <div class="move" style="cursor: move;"><el-icon-d-caret style="width: 1em; height: 1em;" /></div>
        </template>
      </el-table-column>
      <slot></slot>
      <template #empty>
        {{ placeholder }}
      </template>
    </el-table>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    addTemplate: { type: Object, default: () => { } },
    placeholder: { type: String, default: "暂无数据" },
    dragSort: { type: Boolean, default: false },
    hideAdd: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false },
    primaryKey: { type: String, default: 'primaryColumn' },
    height: { type: [String, Number], default: "100%" },
    myTitle: { type: Boolean, default: false },
    myTitleWidth: { type: String, default: '50' },
    isMyTitleDate: { type: Boolean, default: false },
    myTitleDate: { type: Date, default: new Date() },
    showSummary: { type: Boolean, default: false },
    isDefaultSummary: { type: Boolean, default: true },
    mySummary: { type: Function, default: () => { } },
    disableDeleteCondition: { type: Function, default: () => true }
  },
  emits: ['changeData', 'removeData', 'update:modelValue'],
  data() {
    return {
      data: [],
      loading: false
    }
  },
  mounted() {
    this.data = this.modelValue
    if (this.dragSort) {
      this.rowDrop()
    }
  },
  watch: {
    modelValue() {
      this.data = this.modelValue
    },
    data: {
      handler() {
        this.$emit('update:modelValue', this.data);
      },
      deep: true
    }
  },
  computed: {
    _height() {
      return Number(this.height) ? Number(this.height) + 'px' : this.height
    },
    _table_height() {
      return "calc(100% - 50px)"
    }
  },
  methods: {
    rowDrop() {
      const _this = this
      const tbody = this.$refs.table.$el.querySelector('.el-table__body-wrapper tbody')
      Sortable.create(tbody, {
        handle: ".move",
        animation: 300,
        ghostClass: "ghost",
        onEnd({ newIndex, oldIndex }) {
          _this.data.splice(newIndex, 0, _this.data.splice(oldIndex, 1)[0])
          const newArray = _this.data.slice(0)
          const tmpHeight = _this.$refs.scFormTable.offsetHeight
          _this.$refs.scFormTable.style.setProperty('height', tmpHeight + 'px')
          _this.data = []
          _this.$nextTick(() => {
            _this.data = newArray
            _this.$nextTick(() => {
              _this.$refs.scFormTable.style.removeProperty('height')
            })

            _this.$emit('changeData', _this.data);
          })
        }
      });
    },
    rowAdd() {
      const temp = JSON.parse(JSON.stringify(this.addTemplate))
      this.data.push(temp)
      this.$emit('changeData', this.data)
    },
    rowDel(row, index) {
      this.data.splice(index, 1)
      this.$emit('changeData', this.data)
      this.$emit('removeData', row, this.data)
    },
    //插入行
    pushRow(row) {
      const temp = row || JSON.parse(JSON.stringify(this.addTemplate))
      this.data.push(temp)
    },
    //根据index删除
    deleteRow(index) {
      this.data.splice(index, 1)
    },
    covertTitle(title, index) {
      if (this.isMyTitleDate) {
        const startDate = new Date();
        startDate.setTime(this.myTitleDate.getTime())
        startDate.setDate(startDate.getDate() + index)
        return this.$TOOL.dateFormat(startDate, 'yyyy-MM-dd');
      } else {
        return title.replace('${index}', index + 1);
      }
    },
    // 行尾统计
    getSummaries(param) {
      if (this.isDefaultSummary) {
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计：'
            return
          }
          if (index === 1) {
            sums[index] = '';
            return
          }
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => Number.isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0);
          } else {
            sums[index] = ''
          }
        });
        return sums;
      } else {
        return this.mySummary(param);
      }
    }
  }
}
</script>

<style scoped>
.sc-form-table {
  width: 100%;
}

.sc-form-table .sc-form-table-handle {
  text-align: center;
}

.sc-form-table .sc-form-table-handle span {
  display: inline-block;
}

.sc-form-table .sc-form-table-handle button {
  display: none;
}

.sc-form-table .hover-row .sc-form-table-handle-delete span {
  display: none;
}

.sc-form-table .hover-row .sc-form-table-handle-delete button {
  display: inline-block;
}

.sc-form-table .move {
  text-align: center;
  font-size: 14px;
  margin-top: 3px;
}
</style>